export const usStateCityToTimezone: Record<string, Record<string, string>> = {
  alabama: {
    '*': 'America/Chicago',
  },
  alaska: {
    '*': 'America/Anchorage',
  },
  arizona: {
    '*': 'America/Phoenix',
  },
  arkansas: {
    '*': 'America/Chicago',
  },
  california: {
    '*': 'America/Los_Angeles',
  },
  colorado: {
    '*': 'America/Denver',
  },
  connecticut: {
    '*': 'America/New_York',
  },
  delaware: {
    '*': 'America/New_York',
  },
  florida: {
    '*': 'America/New_York',
  },
  georgia: {
    '*': 'America/New_York',
  },
  hawaii: {
    '*': 'Pacific/Honolulu',
  },
  idaho: {
    '*': 'America/Boise',
    'coeur-dalene': 'America/Los_Angeles',
    hayden: 'America/Los_Angeles',
    lewiston: 'America/Los_Angeles',
    moscow: 'America/Los_Angeles',
    'post-falls': 'America/Los_Angeles',
  },
  illinois: {
    '*': 'America/Chicago',
  },
  indiana: {
    '*': 'America/Indiana/Indianapolis',
    gary: 'America/Chicago',
    hammond: 'America/Chicago',
    jeffersonville: 'America/Indiana/Louisville',
    'new-albany': 'America/Indiana/Louisville',
    portage: 'America/Chicago',
  },
  iowa: {
    '*': 'America/Chicago',
  },
  kansas: {
    '*': 'America/Chicago',
  },
  kentucky: {
    '*': 'America/Kentucky/Louisville',
    ashland: 'America/New_York',
    'bowling-green': 'America/Chicago',
    covington: 'America/New_York',
    erlanger: 'America/New_York',
    florence: 'America/New_York',
    henderson: 'America/Chicago',
    hopkinsville: 'America/Chicago',
    independence: 'America/New_York',
    murray: 'America/Chicago',
    owensboro: 'America/Chicago',
    paducah: 'America/Chicago',
  },
  louisiana: {
    '*': 'America/Chicago',
  },
  maine: {
    '*': 'America/New_York',
  },
  maryland: {
    '*': 'America/New_York',
  },
  massachusetts: {
    '*': 'America/New_York',
  },
  michigan: {
    '*': 'America/Detroit',
  },
  minnesota: {
    '*': 'America/Chicago',
  },
  mississippi: {
    '*': 'America/Chicago',
  },
  missouri: {
    '*': 'America/Chicago',
  },
  montana: {
    '*': 'America/Denver',
  },
  nebraska: {
    '*': 'America/Chicago',
    alliance: 'America/Denver',
    gering: 'America/Denver',
    scottsbluff: 'America/Denver',
    sidney: 'America/Denver',
  },
  nevada: {
    '*': 'America/Los_Angeles',
    jackpot: 'America/Denver',
    wells: 'America/Denver',
    'west-wendover': 'America/Denver',
  },
  'new-hampshire': {
    '*': 'America/New_York',
  },
  'new-jersey': {
    '*': 'America/New_York',
  },
  'new-mexico': {
    '*': 'America/Denver',
  },
  'new-york': {
    '*': 'America/New_York',
  },
  'north-carolina': {
    '*': 'America/New_York',
  },
  'north-dakota': {
    '*': 'America/Chicago',
  },
  ohio: {
    '*': 'America/New_York',
  },
  oklahoma: {
    '*': 'America/Chicago',
  },
  oregon: {
    '*': 'America/Los_Angeles',
  },
  pennsylvania: {
    '*': 'America/New_York',
  },
  'rhode-island': {
    '*': 'America/New_York',
  },
  'south-carolina': {
    '*': 'America/New_York',
  },
  'south-dakota': {
    '*': 'America/Chicago',
    'belle-fourche': 'America/Denver',
    deadwood: 'America/Denver',
    'hot-springs': 'America/Denver',
    lead: 'America/Denver',
    'rapid-city': 'America/Denver',
    spearfish: 'America/Denver',
    sturgis: 'America/Denver',
  },
  tennessee: {
    '*': 'America/Chicago',
    chattanooga: 'America/New_York',
    cleveland: 'America/New_York',
    johnson: 'America/New_York',
    kingsport: 'America/New_York',
    knoxville: 'America/New_York',
    maryville: 'America/New_York',
    'oak-ridge': 'America/New_York',
  },
  texas: {
    '*': 'America/Chicago',
  },
  utah: {
    '*': 'America/Denver',
  },
  vermont: {
    '*': 'America/New_York',
  },
  virginia: {
    '*': 'America/New_York',
  },
  washington: {
    '*': 'America/Los_Angeles',
  },
  'west-virginia': {
    '*': 'America/New_York',
  },
  wisconsin: {
    '*': 'America/Chicago',
  },
  wyoming: {
    '*': 'America/Denver',
  },
};
